import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { useGetUserCompanies } from "../../backend/query";
import { useHistory } from "raviger";
import { sortBy } from "underscore";
import { getUserDetails } from "../../backend/auth";


const INCLUDE_USER_COMPANY_ASSOCIATIONS = {
  parent_company: {
    associate_companies: {
      company_location_mappings: {
        location: ['city']
      }
    }
  }
};

function Location({ onChange, previousFilters }: any) {
    const { state }: any = useHistory();
    const [companies, setCompanies] = useState<any[]>([]);
    const [associateCompanies, setAssociateCompanies] = useState<any[]>([]);
    const [locations, setLocations] = useState<any[]>([]);
    const [company, setCompany] = useState<any>(null);
    const [associate_company, setAssociateCompany] = useState<any>(null);
    const [location, setLocation] = useState<any>(null);
    const user = getUserDetails();

    const { userCompanies, isFetching }: any = useGetUserCompanies({
      filters: {
        users_id_eq: user.user_id
      },
      includes: INCLUDE_USER_COMPANY_ASSOCIATIONS
    });

    useEffect(() => {
        setAssociateCompanies([]);
        setLocations([]);
        setAssociateCompany(null);
        setLocation(null);
        if (company) {
            const associateCompanies = (company.company.associate_companies || []).map((associate_company: any) => {
                return {
                    label: associate_company.name,
                    value: associate_company.id,
                    associate_company: associate_company,
                    locations: associate_company.locations
                };
            });
            const sorted: any[] = sortBy(associateCompanies, 'label');
            setAssociateCompanies(sorted);
            const _associate_company = sorted.find((c: any) => c.value === ((previousFilters || {}).associate_company || {}).value);
            setAssociateCompany(_associate_company || sorted[0]);
        }
    }, [company]);

    useEffect(() => {
        setLocations([]);
        setLocation(null);
        if (associate_company) {
            const locations = (associate_company.locations || []).map((location: any) => {
                return { label: `${location.name}, ${location.city.name}`, value: location.id, location, state_id: location.state.id };
            });
            const sorted = sortBy(locations, 'label');
            const _location = sorted.find((c: any) => c.value === ((previousFilters || {}).location || {}).value);
            setLocations(sorted);
            setLocation(_location || sorted[0]);
        }
    }, [associate_company]);

    useEffect(() => {
        if (company && associate_company && location) {
            onChange({
                company: company.value,
                associate_company: associate_company.value,
                location: location.value,
                state_id: location.state_id
            },
            {
                company,
                associate_company,
                location
            });
        }
    }, [location]);

    useEffect(() => {
        if (!isFetching && userCompanies) {
            const companies = userCompanies.map((company: any) => {
                return { value: company.id, label: company.name, company }
            });
            const sorted = sortBy(companies, 'label');
            setCompanies(sorted);
            const _company = sorted.find((c: any) => c.value === ((previousFilters || {}).company || {}).value);
            setCompany(_company || sorted[0]);
        }
    }, [isFetching]);

    return (
        <>
            <div className="px-2">
                <label className="filter-label"><small>Company</small></label>
                <Select placeholder='Company' options={companies} onChange={setCompany} value={company} className="select-control" />
            </div>
            <div className="px-2">
                <label className="filter-label"><small>Associate Company</small></label>
                <Select placeholder='Associate Company' options={associateCompanies} onChange={setAssociateCompany} value={associate_company} className="select-control" />
            </div>
            <div className="px-2">
                <label className="filter-label"><small>Location</small></label>
                <Select placeholder='Location' options={locations} onChange={setLocation} value={location} className="select-control" />
            </div>
        </>
    )
}

export default Location;
